import React from 'react';
import PeptideCalculatorTemplate from '../components/PeptideCalculatorTemplate';
import { PEPTIDE_DATA } from '../data/peptideCalculatorData';

const IpamorelinCalculator = () => {
  return <PeptideCalculatorTemplate peptideData={PEPTIDE_DATA.ipamorelin} />;
};

export default IpamorelinCalculator;
